import MDButton from "../../../components/MDButton";
import {formatCurrency} from "../../common/Utils";
import {Col, Container, Row} from "react-bootstrap";
import {Grid, InputAdornment} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React, {useContext, useEffect, useState} from "react";
import MDInput from "../../../components/MDInput";
import Divider from "@mui/material/Divider";
import {Add, AllInclusive, People, RefreshOutlined, Remove, RemoveCircle} from "@mui/icons-material";
import MDBox from "../../../components/MDBox";
import Checkbox from "@mui/material/Checkbox";
import CafeGroups from "../cart/CafeGroups";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ToggleDetails from "../../common/ToggleDetail";
import MembershipPerks from "../perks/MembershipPerks";
import {CompanyContext} from "../../../lib/CompanyProvider";
import LockedAccountForm from "../form/LockedAccountForm";
import CartGiftCard from "./CartGiftCard";
import Link from "@mui/material/Link";
import {UserContext} from "../../../lib/UserProvider";

export default function InventoryModalBody({
                                             inventory,
                                             quantity,
                                             addToCart,
                                             itemCallback,
                                             cafeCallback,
                                             addFamilyCallback,
                                             membershipCallback,
                                             giftCardRecipientCallback,
                                             formCallback,
                                             doSubmit,
                                             full
                                           }) {
  const [userContext, setUserContext] = useContext(UserContext);
  const [userPresent, setUserPresent] = useState(false);
  useEffect(() => {
    setUserPresent(userContext?.sessionUser?.guid?.length > 0)
  }, [userContext]);

  const [siblingRenderIndex, setSiblingRenderIndex] = useState(1);
  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [formInvalid, setFormInvalid] = useState(false);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [giftCardRecipientSendDate, setGiftCardRecipientSendDate] = useState();
  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(false);

  const [cafeItem, setCafeItem] = useState(inventory?.inventoryType?.cafeItem || false);
  const [cafeOptions, setCafeOptions] = useState();
  const [siblingQuantity, setSiblingQuantity] = useState(0);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [membershipMemberAdults, setMembershipMemberAdults] = useState([]);
  const [membershipMemberChildren, setMembershipMemberChildren] = useState([]);
  const maxQuantity = 10;

  const [addFamily, setAddFamily] = useState(false);

  useEffect(() => {
    addFamilyCallback(addFamily);
  }, [addFamily]);

  const [membershipMembers, setMembershipMembers] = useState([]);
  const [membershipCounts, setMembershipCounts] = useState({adults: 0, children: 0});
  useEffect(() => {
    let arr = [];
    for (let j in membershipMemberAdults) {
      arr.push(membershipMemberAdults[j]);
    }
    for (let j in membershipMemberChildren) {
      arr.push(membershipMemberChildren[j]);
    }
    setMembershipMembers(arr);
  }, [membershipMemberAdults, membershipMemberChildren]);

  useEffect(() => {
    if (inventory?.lockedAccount) {
      const needsAdults = inventory?.numAdults > 0;
      const needsChildren = inventory?.numChildren > 0;
      const valid = inventory?.accountType?.familyPass && (needsAdults || needsChildren)
        ? (!needsAdults || membershipCounts.adults > 0) && (!needsChildren || membershipCounts.children > 0)
        : membershipMembers?.length > 0;
      if (!valid) {
        membershipCallback({
          membershipValid: false
        })
        return;
      }
    }
    membershipCallback({
      membershipValid: true,
      membershipMembers: membershipMembers
    })

  }, [inventory?.lockedAccount, membershipMembers, membershipCounts]);

  useEffect(() => {
    if (inventory?.giftCard) {
      setGiftCardAmount(inventory?.minAmount);
    }
  }, [inventory]);

  return (
    <>
      <Row>
        <Col className={'col col-main'} xs={12}>
          <Container>
            <Row>

              <Grid container>
                <Grid item sm={5}>
                  <Grid container>
                    <Grid item sm={5}>&nbsp;</Grid>
                    <Grid item sm={7}>
                      <Avatar alt={inventory?.name}
                              variant="rounded"
                              sx={{width: '90%', height: 'auto'}}>
                        {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                                     style={{width: '100%', height: 'auto'}}
                                                     alt={inventory?.name}/>}
                      </Avatar>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <h4 style={{
                    display: 'block',
                  }}>
                    <Link href={"#/cx/view-item/" + inventory?.guid}>{inventory.name}</Link>
                  </h4>

                  <div style={{
                    display: 'block',
                  }}>
                    {!inventory?.giftCard && !cafeItem && <>
                      <Col className={'col'} lg={3} md={6} sm={12} xs={12}>
                        <p>
                          <small>
                            <b>Price:</b>&nbsp;
                            <span
                              className={inventory?.accountType?.siblingOptionsEnabled ? 'text-decoration-line-through' : ''}>
                              {formatCurrency(inventory.price)}
                            </span>
                            {inventory?.accountType?.siblingOptionsEnabled && <>
                              <br/>
                              {formatCurrency(inventory.discountPrice)}
                            </>}
                          </small>
                        </p>
                        {quantity > 1 &&
                          <>
                            <p>
                              <small>
                                <b>Price Total:</b>&nbsp;{formatCurrency(inventory.price * quantity)}
                              </small>
                            </p>
                          </>
                        }
                      </Col>
                    </>}

                    {cafeItem && <CafeGroups callback={(c) => {
                      setCafeOptions(c)
                    }}
                                             quantity={quantity}
                                             cafeCallback={cafeCallback}
                                             inventory={inventory}
                                             groups={inventory?.cafeGroups}/>
                    }

                  </div>

                  {inventory?.giftCard && <>
                    <CartGiftCard inventory={inventory} giftCardRecipientCallback={giftCardRecipientCallback}
                                  formCallback={formCallback}/>
                  </>

                  }


                  <div>
                    <MDBox mt={1}>
                      {inventory?.accountType && <>
                        <dl className={'row'}>
                          {inventory?.accountType?.recurring &&
                            <>
                              <dd className={'col col-sm col-sm-12'}>
                                <small><RefreshOutlined/> Recurring
                                  {inventory?.accountType?.recurrencePattern === 'TIME_BASED_RECURRING' && ' every ' +
                                    inventory?.accountType.membershipTimeDays + ' Days'}</small>
                              </dd>
                              {companyContext?.company?.preferences['hide_cancel_anytime'] !== 'true' && <>
                                <dd className={'col col-sm col-sm-12'}>
                                  <small><RemoveCircle/> Cancel at any time</small>
                                </dd>
                              </>}
                            </>
                          }
                          {inventory?.accountType?.unlimitedVisits &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AllInclusive/> Unlimited Visits</small>
                            </dd>
                          }
                          {inventory?.accountType?.timeBased &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AccessTimeIcon/> Expires in
                                Days {inventory?.accountType?.membershipTimeDays}</small>
                            </dd>
                          }

                          {inventory?.siblingMembership && <>
                            <dd className={'col col-sm col-sm-6'}>
                              <small><People/> Sibling Rate {formatCurrency(inventory?.siblingMembership?.price)}
                              </small>
                            </dd>
                          </>}
                        </dl>

                        <MembershipPerks inventory={inventory}/>

                      </>}
                    </MDBox>

                    {inventory?.siblingMembership && <>
                      <Row>
                        <div p={1} style={{
                          margin: '0 auto',
                          padding: '12px',
                          borderLeft: 'solid 2px #ccc',
                          background: inventory.includeSiblingMembership ? '#fff' : '#f8f6f6'
                        }}>
                          <Grid container>
                            <Grid item sm={12}>
                              <h6>
                                <label htmlFor="checkboxMembership">
                                  <Checkbox
                                    id="checkboxMembership"
                                    name="checkboxMembership"
                                    checked={inventory?.includeSiblingMembership || false}
                                    onChange={(e) => {
                                      inventory.includeSiblingMembership = e.target.checked;
                                      let q = 0;
                                      if (!e.target.checked) {
                                        setSiblingQuantity(0);
                                        q = 0;
                                      } else {
                                        setSiblingQuantity(1);
                                        q = 1;
                                      }
                                      setSiblingRenderIndex(siblingRenderIndex + 1);
                                      inventory.siblingQuantity = q;
                                      itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', q)
                                    }}
                                  /> Sibling Add-On
                                </label>
                              </h6>
                              <p>Price: {formatCurrency(inventory?.siblingMembership.price)}</p>

                              <div className={'d-block'}>
                                {siblingRenderIndex > 0 &&
                                  <>
                                    <MDInput type="text" step="1" required
                                             onChange={(e) => {
                                               setSiblingQuantity(e.target.value);
                                               itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', parseInt(e.target.value))
                                             }}
                                             InputProps={{
                                               readOnly: true,
                                               startAdornment: <InputAdornment position="start"
                                                                               className={'cursor-pointer'}
                                                                               onClick={(e) => {
                                                                                 let _q = siblingQuantity - 1;
                                                                                 if (_q >= 0) {
                                                                                   setSiblingQuantity(_q);
                                                                                 } else {
                                                                                   _q = 0;
                                                                                 }
                                                                                 inventory.siblingQuantity = _q;
                                                                                 itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', _q)
                                                                               }}>
                                                 <Remove/>
                                               </InputAdornment>,
                                               endAdornment: <InputAdornment position="end"
                                                                             className={'cursor-pointer'}
                                                                             onClick={(e) => {
                                                                               let _q = siblingQuantity;
                                                                               let _newQ = _q + 1;
                                                                               if (_newQ <= maxQuantity) {
                                                                                 setSiblingQuantity(_newQ);
                                                                                 inventory.includeSiblingMembership = true;
                                                                                 inventory.siblingQuantity = _newQ;
                                                                                 setSiblingRenderIndex(siblingRenderIndex + 1);
                                                                                 itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', _newQ)
                                                                               }
                                                                             }}>
                                                 <Add/>
                                               </InputAdornment>,
                                             }}
                                             value={siblingQuantity || 0}
                                             autoComplete="off"
                                             className="form-control" id="quantity"
                                             label="Quantity"
                                             style={{width: '125px'}}/>

                                  </>
                                }
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Row>
                      <Divider/>
                    </>}

                    {userPresent && inventory?.lockedAccount &&
                      <>
                        <LockedAccountForm inventory={inventory}
                                           siblingQuantity={siblingQuantity}
                                           doSubmit={doSubmit}
                                           addFamilyCallback={(cb) => {
                                             setAddFamily(cb);
                                           }}
                                           callback={(cb) => {
                                             setMembershipMembers(cb?.membershipMembers);
                                             setMembershipCounts({
                                               adults: cb?.numAssignedAdults || 0,
                                               children: cb?.numAssignedChildren || 0
                                             });
                                           }}
                        />
                      </>

                    }

                    {inventory?.desc?.length > 0 && <>
                      <h6>Details</h6>
                      <div style={{
                        clear: 'both',
                        marginTop: '10px',
                        whiteSpace: 'pre-wrap',
                        fontSize: '0.875rem',
                        marginBottom: '20px',
                        maxWidth:'600px'
                      }}>
                        {full && <p>
                          {inventory?.desc}
                        </p>}
                        {!full &&
                          <ToggleDetails text={inventory?.desc} limit={35}/>
                        }
                      </div>
                    </>
                    }
                    {inventory?.accountType?.siblingOptionsEnabled && <p>
                      <b><small>Discount Sibling Rate</small></b>
                    </p>}

                  </div>
                </Grid>
              </Grid>


            </Row>

          </Container>
        </Col>
      </Row>

      {addToCart && <MDButton variant="gradient"
                              color="secondary"
                              size="small"
                              className={'pull-right mt-n1'}
                              onClick={(e) => {
                                addToCart(inventory);
                              }}>Add to Cart
      </MDButton>}
    </>
  )
}